import {createGlobalStyle} from 'styled-components';

const GlobalStyle = createGlobalStyle`
    *{
        margin:0;
        padding:0;
        box-sizing: border-box;
    }  
    body{
        background:#fff;
        color: #344054;
        font-family: 'Comic Sans', arial;
    }
        a{
        color: #101828;
        text-decoration: none;
        }

    .box-login{
      display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        height: 100%;
        position: absolute;
    }

    .box-login-1{
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      
    }
    .box-login-2{
      width: 50%;
      height: 100%;
      position: relative;
    }
    .bg-login-bg{
      background: #fff url('./files/img/login-bg.webp') no-repeat center;    background-size: cover;
      height: 100%;
      width:100%;
    }
    .box-login-all{
      width: 300px;
    }
    .bx-input a:hover{
      color: #3295a9;
    }
    .bx-input a{
      text-decoration:none;
      color:#43acc2;
    }
    .bx-input{
      margin: 10px 0px 10px 0px;
    }
    .form-login input{
      border:1px solid #ddd;
      border-radius: 7px;
      width: 100%;
      background: #fff;
      padding: 9px;
      font-size: 15px;
    }
    .form-login span{
      font-size: 14px;
    }

    .btn{
      padding: 8px 20px;
      font-size: 14px;
      border-radius: 5px;
      font-weight: 600;
      cursor: pointer;
      border:none;
    }
    .btn-1{
      background: #43ACC2;
      width: 100%;
      color: #fff;
    }
    .btn-1:hover{
      background:rgb(50, 151, 171);
    }

    .btn-2{
      background: #20ac45ff;
      color: #fff;
    }
    .btn-2:hover{
      background: #199339ff;
    }

    .btn-3{
      background: #43ACC2;
      color: #fff;
    }
    .btn-3:hover{
      background: #389aadff;
    }

    .btn-4{
      background: #EAECF0;
      color: #fff;
    }
    .btn-5:hover{
      background: #EAECF0;
    }

    .d-flex{
      display: flex;
      justify-content: space-between;
    }

    .box{
      display:flex;
    }

    .box1{
      
    }
    

    .box2{
      width: 100%;
      padding-left: 230px;
    }
    .content-single{
      padding:15px 30px;
    }
    .content-single h1{
       
    }
    .content-sid{
      padding: 15px;
      display: flex;
      flex-direction: column;
          justify-content: space-between;
      height: 100vh;
      position: fixed;
      border-right: 1px solid #EAECF0;
      background: #fff;
    }

    .menu-lateral{
      margin: 15px 0px 0px 0px;
    }

    .menu-lateral-all li{
      margin: 2px 0px;
      list-style: none;
    }
    .menu-lateral-all li a{
      color: #344054;
      text-decoration:none;
      display: flex;
      border-radius: 7px;
      padding: 7px 13px;
      font-size: 15px;
    }
    .menu-lateral-all li a:hover{
      background:#EAECF0;
    }
    .bg-menu-lateral-selected{
      background:#EAECF0;
      border-radius: 7px;
    }
    .menu-lateral-str{
      margin: 2px 0px 0px 5px
    }

    .sid-logo-img{
        width: 100%;
        text-align: center;
        padding: 10px;
    }

    .sid-logo-img img{
      width:130px;
    }

    .sid-search input{
      padding: 10px;
      border-radius: 7px;
      border: 1px solid #ddd;
      width: 100%;
    }

    .user-inf{
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #EAECF0;
      padding: 15px 0px 10px 0px;
      margin: 15px 0px 0px 0px;
    }
    .user-inf-img{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: relative;
      overflow: hidden;
    }
    .user-inf-img img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .user-inf-data{
      margin: 0px 0px 0px 0px;
      color: #999;
    }
    .user-inf-data h2{
      font-size: 14px;
      color: #344054;
      max-width: 17ch;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .user-inf-data h3{
      font-size: 12px;
      color: #475467;
      font-weight: 100;
      max-width: 20ch;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subs{
      margin: 15px 0px 15px 0px;
    }
    .subs h1{
      font-size: 25px;
      font-weight: 300;
    }
      
    .subs h2{
      font-size: 22px;
      font-weight: 300;
    }
    .box-single{
      margin: 10px 0px;
    }
    .box-single-sub-action{
      padding: 25px 0px 10px 0px;
    }
    .box-single-sub-action .box-single-icon-one{
      width: 50%;
      border: 1px solid #EAECF0;
      border-radius: 10px;
      padding: 24px 20px 20px 20px;
      margin-right: 10px;
      display: flex;
      justify-content: initial;
    }
    .box-single-sub-action .box-single-icon-two{
      width: 50%;
      border: 1px solid #EAECF0;
      border-radius: 10px;
      padding: 24px 20px 20px 20px;
      margin-left: 10px;
      justify-content: initial;
    }
    .box-single-sub-action .box-single-icon-one a,.box-single-sub-action .box-single-icon-two a{
      text-decoration:none;
      color: #475467;
    }

    .box-single-sub{
      border-bottom: 1px solid #EAECF0;
      padding: 10px 0px 10px 0px;
    }
    .box-single-sub h2{
      font-size: 17px;
      font-weight: 100;
    }
    .box-single-icon{
      display: flex;
      justify-content: space-between;
    }

    .box-single-search-alig{
      display: flex;
      width: 100%;
      justify-content: end;
    }

    .box-single-icon-one{
      width: 30%;
    }
    .box-single-icon-two{
      width: 100%;
      display: flex;
      justify-content: end;
    }

    .box-single-content{
      margin: 25px 0px 0px 0px;
    }

    .box-single-action-alig{
      display:flex;
    }
    .icon-action-btn-inter{
      border: 1px solid #EAECF0;
      border-radius: 10px;
      padding: 10px;
    }
    .icon-action-content p{
      margin-bottom: 8px;
    }
    .icon-action-content{
      margin-left: 10px;
    }

    /* Tablet (até 1024px) */
    @media screen and (max-width: 1024px) {
      .sid-patient-exc-results .sid-box {
        width: 50%;
      }


    }

    /* Celular (até 600px) */
    @media screen and (max-width: 600px) {
      .box1{
        display: none;
      }
    }
      
`;

export default GlobalStyle;